// import React, { useState } from "react";
// import { Outlet } from "react-router-dom";
// import ProfileDrawer from "./ProfileSidebar ";

// const ProfileLayout = () => {
//   const [isCollapsed, setIsCollapsed] = useState(false);

//   const drawerWidth = isCollapsed ? "w-20" : "w-72";

//   return (
//     <div className="relative w-full  bg-gray-50 overflow-hidden">
//       {/* Sidebar */}
//       <ProfileDrawer isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />

//       {/* Main Content */}
//       <div
//         className={`flex-1 transition-all duration-300 ${
//           isCollapsed ? "ml-20" : "ml-72"
//         } p-4 bg-gray-50`}
//       >
//         <Outlet />
//       </div>
//     </div>
//   );
// };

// export default ProfileLayout;

// ProfileLayout.jsx
import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import ProfileDrawer from "./ProfileSidebar ";
import Header from "./UserHeader";

const ProfileLayout = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="relative w-full  bg-gray-50 overflow-hidden">
      {/* <Header/> */}
      <ProfileDrawer
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
      />

      <main
        className={`
           flex-1 p-2  transition-all duration-300
          ${isMobile ? "" : isCollapsed ? "ml-20 " : "ml-72 " }
        `}
      >
        <div className=" ">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default ProfileLayout;
